import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UploadFileDialogComponent } from '../../dialogs/upload-file-dialog/upload-file-dialog.component';
import { DocumentConstants, DocumentExtensionHandling } from 'app/constants/document.constants';
import { FormService } from 'app/services/form.service';
import { AttachmentModel } from 'app/models/attachment.model';

@Component({
  selector: 'app-antibody-drug-conjugates',
  templateUrl: './antibody-drug-conjugates.component.html',
  styleUrls: ['./antibody-drug-conjugates.component.scss']
})
export class AntibodyDrugConjugatesComponent {
  fileUploaded = false;
  private allowedFileTypes = [ ...DocumentExtensionHandling.CHEMDRAW_FILE_EXTENSIONS, ...DocumentExtensionHandling.MS_WORD_FILE_EXTENSIONS ];
  private acceptedFileTypes = [ ...DocumentExtensionHandling.CHEMDRAW_ACCEPT_TYPE, ...DocumentExtensionHandling.MS_WORD_ACCEPT_TYPE ];
  readonly dialog = inject(MatDialog);

  constructor(protected formService: FormService) {}

  public openDialog(): void {
    const dialogRef = this.dialog.open(UploadFileDialogComponent, {
      data: {
        fileName: DocumentConstants.ANTIBODY_DRUG_CONJUGATES,
        allowedFileTypes: this.allowedFileTypes,
        fileAcceptTypes: this.acceptedFileTypes
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.fileUploaded = true;
      }
    });
  }

  get wasFileUploaded(): boolean {
    const fileName = DocumentConstants.ANTIBODY_DRUG_CONJUGATES;
    if(!fileName) {
      return false;
    }

    return this.formService.doesCurrentFormHaveAttachmentForSection(fileName);
  }

  get attachments(): AttachmentModel[] {
    return this.formService.allAttachmentsForSection(DocumentConstants.ANTIBODY_DRUG_CONJUGATES);
  }

  get formType(): string {
    return this.formService.getCurrentUsanFormType();
  }
}
